class Contact {
    public firstname: string;
    public surname: string;
    public tel1: string;
    public tel2: string;
    public email: string;

    constructor(firstname?: string, surname?: string, tel1?: string, tel2?: string, email?: string) {
        this.firstname = firstname || '';
        this.surname = surname || '';
        this.tel1 = tel1 || '';
        this.tel2 = tel2 || '';
        this.email = email || '';
    }
}

export default Contact;
